module.exports = __webpack_public_path__ + "static/media/Student_Card_logo.4444bd9e.svg";